import {
  useQuery,
  UseQueryOptions,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { ID, IdProvider, Timestamp, unwrap } from '../common/apiCommons';
import axios from 'axios';

export const PAUSE_WARNING = 'pauseWarning';

export interface PauseWarning {
  type: string;
  id: ID;
  seen_by_admin: boolean;
  resolved: boolean;
  employee: ID;
  date: ID;
  reason: string;
}

type PauseWarningQueryParams = IdProvider & {
  start: Timestamp;
  end: Timestamp;
};
const queries = {
  async getEmployeeWarnings(request: PauseWarningQueryParams) {
    if (!request.id) {
      return null;
    }
    const res = await axios.get<PauseWarning[]>(
      `/warnings/ignored_pause_timer/?employee=${request.id}&start=${request.start}&end=${request.end}`,
    );
    return unwrap(res);
  },
};

const mutations = {
  async seenWarning(warning: PauseWarning) {
    const res = await axios.post<void>(
      `/warnings/ignored_pause_timer/seen/${warning.id}/`,
    );
    return unwrap(res);
  },
};

const hooks = {
  useEmployeeWarnings(
    request: PauseWarningQueryParams,
    options?: UseQueryOptions<PauseWarning[] | null>,
  ) {
    return useQuery({
      queryKey: [PAUSE_WARNING, request.id, request.start, request.end],
      queryFn: () => queries.getEmployeeWarnings(request),
      enabled: !!request && !!request.start && !!request.end && !!request.id,
      ...(options ?? {}),
    });
  },
  useAdminHasSeenWarning() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: mutations.seenWarning,
      onSuccess: async (_data, params) => {
        await queryClient.invalidateQueries([PAUSE_WARNING, params.employee]);
      },
    });
  },
};

const PauseWarningApi = { queries, mutations, hooks };

export default PauseWarningApi;
